import { MulticastChannel, stdChannel } from 'redux-saga';

const channel: MulticastChannel<any> = stdChannel();

export function getChannel() {
  return channel;
}
